module.exports = __webpack_public_path__ + "static/media/CreateTimetableInactive.cccec955.png";